
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evaluation",
      function () {
        return require("private-next-pages/evaluation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evaluation"])
      });
    }
  